import styled from 'styled-components';
import { getColor } from 'core/utils';

export const Background = styled.div`
	content: '';
	width: 100%;
	height: 18px;
	background: ${getColor('concreteGray')};
	border-radius: 100px;
	overflow: hidden;
	position: relative;
`;

/* needs no z-index. if you need z-index, consider: https://cl.ly/0f2d9897a584 */
export const Foreground = styled.div`
	transition: 800ms;
	content: '';
	width: ${props => props.width};
	height: 100%;
	background: ${getColor('pelorous')};
	border-radius: 100px;
	position: absolute;
	top: 0;
	left: 0;
`;
